// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.log-async-loading {
  padding-left: 20px;
  height: 20px;
  width: 100%;
}

.pl-reader {
  background-color: rgba( 255, 255, 255 ,  1 );
  background-color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  color: rgba( 51, 51, 51 ,  1 );
  color: rgba( var(--palette-neutral-80,51, 51, 51) ,  1 );
  font-family: Menlo, Consolas, Courier New, monospace;
  line-height: 20px;
  outline: none;
}
.pl-reader .status-icon {
  min-width: 16px;
}
.pl-reader .is-link:hover {
  color: rgba(0, 90, 158, 1);
  color: var(--communication-foreground,rgba(0, 90, 158, 1));
}
.pl-reader .status-spinner {
  min-width: 16px;
}
.pl-reader .status-spinner .bolt-spinner-circle {
  border-top-color: rgba( 76, 76, 76 ,  1 );
  border-top-color: rgba( var(--palette-neutral-70,76, 76, 76) ,  1 );
  box-sizing: content-box;
}
.pl-reader .line-icon {
  min-width: 20px;
  font-size: 0.75rem;
  vertical-align: bottom;
}
.pl-reader .group-expand .group-icon {
  left: -16px;
  top: -3px;
  padding: 3px !important;
  position: absolute;
  font-size: 7px;
  min-width: 8px;
  color: rgba( 76, 76, 76 ,  1 );
  color: rgba( var(--palette-neutral-70,76, 76, 76) ,  1 );
}
@media screen and (max-width: 599px) {
  .pl-reader .group-expand .group-icon {
    position: inherit;
  }
}
.pl-reader .group-expand .rotate {
  transform: rotate(90deg);
}
.pl-reader .lines-content {
  margin: 10px 20px 16px 20px;
}
@media screen and (max-width: 599px) {
  .pl-reader .lines-content {
    margin: 0;
  }
}
.pl-reader .faint > circle {
  fill: rgba( 76, 76, 76 ,  1 );
  fill: rgba( var(--palette-neutral-70,76, 76, 76) ,  1 );
}
.pl-reader .faint > path {
  fill: rgba( 255, 255, 255 ,  1 );
  fill: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
}
.pl-reader .faint.neutral circle {
  fill: rgba( 255, 255, 255 ,  1 );
  fill: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
}
.pl-reader .faint.neutral path {
  fill: rgba( 76, 76, 76 ,  1 );
  fill: rgba( var(--palette-neutral-70,76, 76, 76) ,  1 );
}
.pl-reader .reader-main-content {
  overflow: visible;
  white-space: pre-wrap;
}
.pl-reader .loading {
  padding: 20px;
  margin-left: 6px;
}
.pl-reader .dt-fm {
  background-color: rgba( 214, 127, 60 ,  1 );
  background-color: rgba( var(--palette-accent3,214, 127, 60) ,  1 );
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
.pl-reader .dt-fm.select {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--communication-background,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--text-on-communication-background,rgba(255, 255, 255, 1));
}
.pl-reader .sentinel {
  display: block;
  height: 1px;
}
.pl-reader .content-area .hide {
  display: none;
}
.pl-reader .sec-sticky {
  left: 20px;
  top: -3px;
  position: sticky;
  z-index: 1;
}
.pl-reader .sec-area {
  left: 20px;
  position: sticky;
  flex-shrink: 1;
  border-radius: 4px;
  z-index: 1;
  margin: 1px 20px 0px 20px;
  box-sizing: content-box;
  height: 34px;
  font-size: 0.875rem;
  font-weight: normal;
  font-family: Menlo, Consolas, Courier New, monospace;
  background-color: rgba( 255, 255, 255 ,  1 );
  background-color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  color: rgba( 51, 51, 51 ,  1 );
  color: rgba( var(--palette-neutral-80,51, 51, 51) ,  1 );
}
.pl-reader .sec-area:hover {
  background-color: rgba( 239, 239, 239 ,  1 );
  background-color: rgba( var(--palette-neutral-6,239, 239, 239) ,  1 );
}
.pl-reader .sec-area.expand {
  background-color: rgba( 239, 239, 239 ,  1 );
  background-color: rgba( var(--palette-neutral-6,239, 239, 239) ,  1 );
}
.pl-reader .sec-area .status-area {
  left: -4px;
  position: sticky;
  margin-left: 4px;
  min-width: 0px;
}
.pl-reader .sec-area .status-area .sec-content {
  min-width: 0px;
  margin-right: 20px;
}
.pl-reader .sec-area .title {
  margin-left: 20px;
}
.pl-reader .sec-area .far-right {
  margin-right: 12px;
}
.pl-reader .sec-area.hide {
  display: none;
}
.pl-reader .sec-area.disabled {
  color: rgba(0, 0, 0, .38);
  color: var(--text-disabled-color,rgba(0, 0, 0, .38));
}
@media screen and (max-width: 599px) {
  .pl-reader .sec-area {
    margin: 0;
    border-radius: 0;
  }
}
.pl-reader .content-area .line-row {
  cursor: text;
  padding: 0px 12px 0px 12px;
  white-space: pre-wrap;
}
.pl-reader .content-area .line-row.group-item {
  cursor: pointer;
}
@media screen and (max-width: 599px) {
  .pl-reader .content-area .line-row {
    padding: 0;
  }
}
.pl-reader .content-area .line-area {
  user-select: text;
  -ms-user-select: text;
  -moz-user-select: text;
  -webkit-user-select: text;
}
.pl-reader .content-area .line-area:hover {
  background-color: rgba( 239, 239, 239 ,  1 );
  background-color: rgba( var(--palette-neutral-6,239, 239, 239) ,  1 );
}
.pl-reader .content-area .line-area:hover .link {
  visibility: visible;
}
.pl-reader .content-area.linkable .link {
  height: 20px;
  margin-right: 25px;
  visibility: hidden;
}
.pl-reader .content-area.linkable .link:hover {
  cursor: pointer;
}
.pl-reader ol {
  padding: 0;
  margin: 0;
}
.pl-reader ol .line-area .line {
  color: rgba( 102, 102, 102 ,  1 );
  color: rgba( var(--palette-neutral-60,102, 102, 102) ,  1 );
  text-align: right;
  padding-left: 20px;
  min-width: 33px;
  user-select: none;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
}
.pl-reader ol .line-area .line::before {
  content: attr(data-line);
}
.pl-reader ol .line-area.highlight {
  background-color: rgba( 218, 218, 218 ,  1 );
  background-color: rgba( var(--palette-neutral-10,218, 218, 218) ,  1 );
}
.pl-reader ol .line-area .content {
  word-break: break-all;
  margin-left: 20px;
  position: relative;
  margin-right: 12px;
}
.pl-reader ol .line-area .content .pl-command {
  color: #66bdff;
}
.pl-reader ol .line-area .content .pl-debug {
  color: #ae99ff;
}
.pl-reader ol .line-area .content .pl-error {
  color: #d53333;
}
.pl-reader ol .line-area .content .pl-info {
  color: #888888;
}
.pl-reader ol .line-area .content .pl-verbose {
  color: #888888;
}
.pl-reader ol .line-area .content .pl-warning {
  color: #a2651b;
}
.pl-reader ol .line-area .content .pl-section {
  color: #73e58c;
}
@media screen and (max-width: 599px) {
  .pl-reader ol .line-area .content {
    margin-left: 8px;
  }
}
.pl-reader ol button.line-area {
  background: transparent;
  border: 0;
  text-align: left;
  justify-content: flex-start;
  width: 100%;
  padding: 0px;
  font-size: 0.75rem;
  font-weight: normal;
  font-family: Menlo, Consolas, Courier New, monospace;
  background-color: rgba( 255, 255, 255 ,  1 );
  background-color: rgba( var(--palette-neutral-0,255, 255, 255) ,  1 );
  color: rgba( 51, 51, 51 ,  1 );
  color: rgba( var(--palette-neutral-80,51, 51, 51) ,  1 );
  line-height: 20px;
}
.pl-reader ol button.line-area.highlight {
  background-color: rgba( 218, 218, 218 ,  1 );
  background-color: rgba( var(--palette-neutral-10,218, 218, 218) ,  1 );
}
.pl-reader ol button.line-area:hover {
  background-color: rgba( 239, 239, 239 ,  1 );
  background-color: rgba( var(--palette-neutral-6,239, 239, 239) ,  1 );
}

/*# sourceMappingURL=LogViewer.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-pipelines-ui/src/Components/LogViewer/LogViewer.scss","webpack://./../azure-pipelines-ui/bin/Components/LogViewer/LogViewer.css","webpack://./../azure-pipelines-ui/node_modules/azure-devops-ui/Core/_platformCommon.scss"],"names":[],"mappings":"AAoBA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;ACnBJ;;ADsBA;EACI,4CEsEI;EFrEJ,qEE4BS;EF3BT,8BEuOkB;EF1PlB,wDAAA;EAqBA,oDAAA;ECnBF,iBAAiB;EDqBf,aAAA;ACnBJ;AACA;EDsBI,eAAA;ACpBJ;AACA;EDuBI,0BAAA;EAnCA,0DAAA;ACeJ;ADsBQ;EAEI,eAAA;ACrBZ;AACA;EDyBI,yCAAA;EACI,mEAAA;EACA,uBEsNG;AD7OX;AACA;ED4BQ,eAAA;EACI,kBAAA;EACA,sBAAA;AC1BZ;AACA;ED4BY,WAAA;EACA,SAAA;EACA,uBELC;EDrBX,kBAAkB;ECyThB,cAAA;EFtSI,cAAA;EChBN,8BD0Bc;ECzBd,wDAAwD;AAC1D;AD4BQ;EACI;IC1BR,iBAAiB;ED8BjB;AC5BJ;AACA;EC8SI,wBAAA;AD5SJ;AACA;EACE,2BAA2B;AAC7B;AD+BQ;EACI;IC7BR,SAAS;ED+BL;AC7BR;AACA;EDgCY,6BAAA;EACI,uDEGR;ADjCR;ADgCY;EACI,gCErCH;EDOX,yDAAyD;ADmCvD;ACjCJ;EDoCQ,gCAAA;EClCN,yDAAyD;ADqCvD;ACnCJ;EDqCQ,6BAAA;ECnCN,uDAAuD;ADsCrD;ACpCJ;EDsCQ,iBEsCU;ED1EhB,qBAAqB;ADqCf;ACnCR;EDqCY,aEwDuB;ED3FjC,gBAAgB;ADuCd;ACrCJ;EDuCQ,2CAAA;ECrCN,kEAAkE;EDyC5D,6BAAA;EACI,qDAAA;ACvCZ;AD0CI;EACI,sCAAA;EACA,sEAAA;EACA,6BAAA;EACA,qEAAA;ACxCR;AD2CI;EACI,cAAA;EACA,WAAA;ACzCR;AACA;ED2CQ,aAAA;ACzCR;AACA;ED2CQ,UAAA;EAEA,SAAA;EACA,gBEuIW;EFtIX,UAAA;AC1CR;AACA;EACE,UAAU;ED4CJ,gBAAA;EACI,cAAA;EC1CV,kBAAkB;ED6CZ,UAAA;EACI,yBE5EA;EDiCV,uBAAuB;ED6CjB,YAAA;EACI,mBAAA;EACA,mBAAA;EACA,oDAAA;EACA,4CAAA;EC3CV,qEAAqE;ED6C3D,8BAAA;EACI,wDAAA;AC3ChB;AACA;ED8CQ,4CAAA;EACI,qEAAA;AC5CZ;AD8CQ;EACI,4CAAA;EC5CV,qEAAqE;AD8C/D;AC5CR;EACE,UAAU;ED8CJ,gBAAA;EACI,gBElBI;ED1Bd,cAAc;ACqNZ;ADnNJ;EACE,cD6CU;EC5CV,kBD6CU;AC5CZ;AACA;EDgDQ,iBAAA;AC9CR;AACA;EDgDY,kBAAA;AC9CZ;ADgDY;EACI,aAAA;AC9ChB;ACuMI;EF/JI,yBAAA;ECrCN,oDD+Cc;AC9ChB;AACA;EDgDQ;IAhMJ,SAAA;IACA,gBAgMwB;EA/LxB;ACmJJ;AACA;ED4CY,YAAA;EACI,0BE7HJ;EDmFV,qBAAqB;AD2CP;ACzChB;EACE,eAAe;AD+CL;AC7CZ;ED+CgB;IACA,UAAA;EC7Cd;AD8Cc;AC5ChB;EACE,iBAAiB;EDkDf,qBAAA;EACI,sBAAA;EACA,yBAAA;AChDR;ADkDY;EACI,4CEzKH;EF0KG,qEAAA;AChDhB;AACA;ED7KI,mBA+N4B;AChDhC;AACA;ED7KI,YAAA;EC+KF,kBAAkB;ED8CJ,kBAAA;AC5ChB;AACA;EDgDY,eAAA;AC9CZ;AACA;EDiDY,UAAA;EACI,SAAA;AC/ChB;AACA;EDiDgB,iCAAA;EC/Cd,2DAA2D;EDiD7C,iBAAA;EACI,kBAAA;EC/ClB,eAAe;EDiDD,iBAAA;EACI,qBAAA;EC/ClB,sBAAsB;EDiDR,yBAAA;AC/ChB;AACA;EDiDgB,wBAAA;AC/ChB;AACA;EDiDgB,4CAAA;EACI,sEAAA;AC/CpB;ADiDgB;EACI,qBAAA;EC/ClB,iBAAiB;EDiDH,kBAAA;EACI,kBAAA;AC/CpB;AC+HI;EFzGQ,cAAA;ACnBZ;AACA;EACE,cAAc;ADkDR;AChDR;EDkDY,cAAA;AChDZ;AACA;EDmDY,cAAA;ACjDZ;AACA;EDoDY,cELO;AD7CnB;AACA;EDoDY,cE7OC;AD2Lb;AACA;EDmDY,cAAA;ACjDZ;AACA;EDmDY;IACI,gBEvNJ;EDsKV;AACF;AACA;EACE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oDAAoD;EACpD,4CAA4C;EAC5C,qEAAqE;EACrE,8BAA8B;EAC9B,wDAAwD;EACxD,iBAAiB;AACnB;AACA;EACE,4CAA4C;EAC5C,sEAAsE;AACxE;AACA;EACE,4CAA4C;EAC5C,qEAAqE;AACvE;;AAEA,wCAAwC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
